import { Strategy as StrategyType } from './utils'
import Styles from './StrategiesSelection.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { StrategyMobile } from './StrategyMobile'
import { StrategyHeader } from './StrategyHeader/StrategyHeader'
import { StrategyValues } from './StrategyValues'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { StrategyValuesV2 } from './StrategyValuesV2'

export interface StrategyProps {
  strategy: StrategyType
  onSelect: (strategyId: string) => void
}

export const Strategy = ({ strategy, onSelect }: StrategyProps) => {
  const { isMobile } = useResponsiveDesign()
  const isNewPostContentTypesEnabled = useFlipperFlag('post_content_types')

  if (isMobile) {
    return <StrategyMobile strategy={strategy} onSelect={onSelect} />
  }

  return (
    <div
      className={cx(Styles.strategyContainer, {
        [Styles.isSelected]: strategy.isSelected,
      })}
      onClick={() => {
        if (!strategy.isSelected) {
          onSelect(strategy.id)
        }
      }}
    >
      <div className={Styles.strategyContent}>
        <StrategyHeader strategy={strategy} />
        {strategy.isSelected && (
          <>
            {isNewPostContentTypesEnabled ? (
              <>
                <Text variant="metadata" color="var(--dark-40)">
                  Content per week
                </Text>
                <StrategyValuesV2 strategy={strategy} />
              </>
            ) : (
              <StrategyValues strategy={strategy} />
            )}
          </>
        )}
      </div>
    </div>
  )
}
